import React, { Component } from 'react';
import Helmet from 'react-helmet';
import { connect } from 'react-redux';
import { Container } from 'react-bootstrap';

import Loading from '../../components/Loading/Loading';
import { getStats } from '../Dashboard/DashboardActions';

import '../../assets/styles/_table.scss';

class Students extends Component {
  componentDidMount() {
    if (!this.props.total) {
      this.props.getStats();
    }
  }

  renderRow = (contact, i) => {
    return (
      <tr key={i}>
        <td><p>{contact.email}</p></td>
        <td><p>{contact.name}</p></td>
        <td><p>{contact.masterclassTime}</p></td>
        <td><p>{!!contact.attended ? 'Yes' : 'No'}</p></td>
        <td><p>{!!contact.enrolled ? 'Yes' : 'No'}</p></td>
      </tr>
    );
  };

  render() {
    const { isLoading, results, total } = this.props;

    return [
      <Helmet key="0" title="Students" />,
      <Container key="1">
        <div>
          <div className='table-content'>
            <div className='table-filter'>
              <h2>Students</h2>
            </div>

            {isLoading && (
              <div className='table-loading'>
                <Loading />
              </div>
            )}
            {!isLoading && total === 0 && (
              <div className='no_data'>
                <p> No data available </p>
              </div>
            )}
            <div className='table'>
              <table>
                <thead>
                  <tr>
                    <th>Email</th>
                    <th>Name</th>
                    <th>Masterclass Time</th>
                    <th>Attended</th>
                    <th>Enrolled</th>
                  </tr>
                </thead>
                <tbody>
                  {!isLoading && results.map((c, i) => this.renderRow(c, i))} 
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </Container>,
    ];
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    getStats: () => dispatch(getStats()),
  };
};

function mapStateToProps(state) {
  return {
    isLoading: state.dashboard.isLoading,
    results: !!state.dashboard.stats && !!state.dashboard.course ? state.dashboard.stats.course.contacts : [],
    total: !!state.dashboard.stats && !!state.dashboard.course ? state.dashboard.stats.course.contacts.length : 0,
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Students);
